export default __webpack_public_path__ + "static/media/bonus_reject.489990cd.svg";